import { createI18n } from 'vue-i18n'

export const DEFAULT_LOCALE = 'frch'

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      const localeMessages = locales(key)
      messages[locale] = localeMessages.default || localeMessages
    }
  })

  if (messages.frch && !messages.fr_ch) {
    messages.fr_ch = messages.frch
  }

  if (messages.frch && !messages['fr-CH']) {
    messages['fr-CH'] = messages.frch
  }

  return messages
}

const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: loadLocaleMessages(),
})

const resolveGlobalMethod = method => (...args) => {
  if ((method === 't' || method === 'tc') && (args[0] === undefined || args[0] === null)) {
    return ''
  }

  if (typeof i18n.global[method] === 'function') {
    return i18n.global[method](...args)
  }

  if (method === 'tc') {
    return i18n.global.t(...args)
  }

  return undefined
}

const getLocaleValue = locale => {
  if (locale && typeof locale === 'object' && Object.prototype.hasOwnProperty.call(locale, 'value')) {
    return locale.value
  }

  return locale
}

const setLocaleValue = value => {
  if (i18n.global.locale && typeof i18n.global.locale === 'object' && Object.prototype.hasOwnProperty.call(i18n.global.locale, 'value')) {
    i18n.global.locale.value = value
    return
  }

  i18n.global.locale = value
}

Object.defineProperties(i18n, {
  t: {
    value: resolveGlobalMethod('t'),
  },
  tc: {
    value: resolveGlobalMethod('tc'),
  },
  te: {
    value: resolveGlobalMethod('te'),
  },
  d: {
    value: resolveGlobalMethod('d'),
  },
  n: {
    value: resolveGlobalMethod('n'),
  },
  locale: {
    get() {
      return getLocaleValue(i18n.global.locale)
    },
    set(value) {
      setLocaleValue(value)
    },
  },
})

export default i18n
